import React from 'react';
import ProductCard from '../ProductCard/ProductCard';
import './CategorySection.css';

const CategorySection = ({ title, products }) => {
  return (
    <div className="category-section">
      <div className="category-header">
        <h3 className="category-title">{title}</h3>
      </div>
      <div className="product-grid">
        {products.map((product, idx) => (
          <ProductCard
            key={idx}
            image={product.image}
            title={product.title}
          />
        ))}
      </div>
    </div>
  );
};

export default CategorySection;
